import { FormEvent, useEffect, useState } from "react";
import { ActionByType } from "../../common/ProfileDocument";
import { TrainingDocument } from "../../common/TrainingDocument";
import { useUpdateTrainingDocumentMutation } from "../../redux/api/trainingDocument";
import { Edit } from "@mui/icons-material";
import { Button, Checkbox, Dialog, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGetTrainingsQuery } from "../../redux/api/training";
import { toast } from "react-toastify";


interface TrainingDocumentUpdateModalProps {
    document: TrainingDocument;
    onUpdate: Function;
    actionByType: ActionByType;
}

const TrainingDocumentUpdateModal = (
    props: TrainingDocumentUpdateModalProps
) => {
    const [trainingDocument, setTrainingDocument] = useState<TrainingDocument>(props.document)
    const [open, setOpen] = useState(false);
    const [updateTrainingDocument] = useUpdateTrainingDocumentMutation();

    const { data: trainings, isLoading, isFetching } = useGetTrainingsQuery();

    useEffect(() => {
        setTrainingDocument({ ...props.document, actionByType: props.actionByType });
    }, [props.document, props.actionByType]);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const clearForm = () => {
        setTrainingDocument({
            id: 0,
            fileUrl: "",
            fileKey: "",
            contentType: "",
            training: undefined,
            issueDate: "",
            expirationDate: "",
            lifetimeValidity: false,
            displayName: "",
            actionByType: props.actionByType,
        });
    };

    const handleTrainingChange = (trainingId: number) => {
        setTrainingDocument({
          ...trainingDocument,
          training: trainings!.find(t => t.id === trainingId),
        })
      }

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        if (trainingDocument.lifetimeValidity !== (trainingDocument.expirationDate.length === 0)) {
            toast.error(<p>A document must either have lifetime validity or an expiration date.</p>, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            return;
        }
        updateDocument(trainingDocument);
    };

    const updateDocument = async (profileDocument: TrainingDocument) => {
        const response = await updateTrainingDocument({
            trainingDocumentId: props.document.id.toString(),
            trainingDocument,
        });

        if ("error" in response === false) {
            handleClose();
            clearForm();
            props.onUpdate();
        }
    };

    return (
        <>
            <Button className="blue-link-button" onClick={handleOpen}>
                <Edit />
                Edit
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                className="modal"
            >
                <div className="modal-header mb-2">
                    <Typography id="modal-title" variant="h3">
                        Update Document
                    </Typography>
                    <Button onClick={() => setOpen(false)} className="grey-link-button">
                        <CloseIcon />
                    </Button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-narrow">
                        {!isFetching && !isLoading && <div>
                            <InputLabel id="trainingLabel">Training</InputLabel>
                            <Select
                                labelId="trainingLabel"
                                id="training"
                                notched={false}
                                value={trainingDocument.training?.id}
                                label="Training"
                                onChange={(event) => {
                                    handleTrainingChange(+event.target.value)
                                }}
                            >
                                {trainings?.map((training) => (
                                    <MenuItem key={training.name} value={training.id}>
                                        {training.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>}
                        <label htmlFor="issueDate">
                            <span>Issue Date:</span>
                            <input
                                type="date"
                                id="issueDate"
                                value={trainingDocument.issueDate}
                                onChange={(event) =>
                                    setTrainingDocument({
                                        ...trainingDocument,
                                        issueDate: event.target.value,
                                    })
                                }
                            />
                        </label>
                        <div>
                            <label htmlFor="expirationDate">
                                <span>Expiration Date:</span>
                                <input
                                    type="date"
                                    id="expirationDate"
                                    value={trainingDocument.expirationDate}
                                    onChange={(event) =>
                                        setTrainingDocument({
                                            ...trainingDocument,
                                            expirationDate: event.target.value,
                                        })
                                    }
                                />
                            </label>
                            <label htmlFor="lifetimeValidity">
                                <span style={{ marginTop: "10px" }}>Lifetime Validity:</span>
                                <div style={{ width: "100px" }}
                                >
                                    <Checkbox
                                        name="lifetimeValidity"
                                        checked={trainingDocument.lifetimeValidity}
                                        onChange={(e) => setTrainingDocument({ ...trainingDocument, lifetimeValidity: e.target.checked ? true : false })}
                                    />
                                </div>

                            </label>
                        </div>

                    </div>
                    <input
                        type="submit"
                        value="Update Document"
                        className="blue-button-small modal-button"
                    />
                </form>
            </Dialog>
        </>
    )
};

export default TrainingDocumentUpdateModal;